import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CompletedImg from '../../../assets/completed.svg';
import PuzzleImg from '../../../assets/puzzle.svg';
import Blockquote from '../../../components/Blockquote';
import Button from '../../../components/Button';
import Notification from '../../../components/Notification';
import useModal from '../../../hooks/useModal';
import { AuthStore } from '../../../providers/auth';
import { EnrollmentStore } from '../../../providers/enrollment';
import { PROFILE_ROUTE } from '../../../routes/types';
import { getAllNotifications } from '../../../services/notifications';
import {
  addOrRemoveDaysToGivenDate,
  COBRA_PERSONAS,
  DateFormats,
  formatDate,
  formatPrice,
} from '../../../utils/utils';
import BenefitElectionModal from '../BenefitElectionsModal/BenefitElectionsModal';

const EnrollmentSuccess = ({ setSubmitted }: any) => {
  const initialDate = new Date();
  const dueDate = new Date("2023-01-31 23:59:00");
  const notifications = getAllNotifications()
    .filter((x, idx) => x.title.includes('Make'))
    .map((e) => {
      if (e.date) {
        const date = formatDate(addOrRemoveDaysToGivenDate(new Date(), 30));

 
        if (date) {
          e.date = date;
        }
      }
      return e;
    });

  const [, , , selectedPersona] = useContext(AuthStore) || [];
  const { updatedCost } = useContext(EnrollmentStore) || {};

  const [
    showBenefitElectionsModal,
    handleShowBenefitElectionsModal,
    handleCloseBenefitElectionsModal,
  ] = useModal();

  return (
    <Container
      className={
        'cnd-custom-container-small my-12 px-0 px-lg-0 border-light-gray rounded-1'
      }
    >
      <Container className="d-flex flex-column px-10 py-11 px-lg-11">
        <Row>
          <Col className="">
          <h4 className="m-0 mb-5">Enroll in COBRA coverage</h4>
          </Col>
        </Row>
        <Row>
          <Col className={'col-12 text-center'}>
            <h5 className="m-0">Submitted! You are almost done</h5>
          </Col>
          <Col className={'col-12 text-center mt-4'}>
            <span className="text-sub1 fw-light lh-xs">{`${
              !(COBRA_PERSONAS.indexOf(selectedPersona) > -1)
                ? 'Submitted! You are almost done'
                : 'You still have required actions below'
            }`}</span>
          </Col>
          <Col className={'col-12 text-center'}>
            <span className="text-sub1 fw-light lh-xs">
              {`${
                !(COBRA_PERSONAS.indexOf(selectedPersona) > -1)
                  ? 'You still have required actions below'
                  : ''
              }`}
            </span>
          </Col>
          <Col className={'col-12 text-center mt-7'}>
            <img
              src={
                !(COBRA_PERSONAS.indexOf(selectedPersona) > -1)
                  ? CompletedImg
                  : PuzzleImg
              }
              alt="puzzle-img"
            />
          </Col>
        </Row>
        <Row className={'mt-11 align-items-center'}>
          <Col className={'col-6 text-start'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span
                className={'text-start text-sub1 fw-normal lh-xs'}
              >
                Per-pay-period
              </span>
            </Container>
          </Col>
          <Col className={'col-6 text-end'}>
            <span
              className={'text-start text-fs-5 text-sub1 fw-normal lh-xs text-center text-lg-start fw-light'}
            >
              {formatPrice(updatedCost, 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 0,
              })}
            </span>
          </Col>
        </Row>
        <Row className={'border-top-light-gray mb-4 pt-4'}>
          <Col className={'col-6 text-start'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span className={'text-start text-sub1 fw-normal lh-xs'}>
                Before-Tax
              </span>
            </Container>
          </Col>
          <Col className={'col-6 text-end'}>
            <span
              className={'text-start text-caption fw-light'}
            >
              {formatPrice(updatedCost - 17.5, 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 2,
              })}
            </span>
          </Col>
        </Row>
        <Row className={'border-top-light-gray mb-4 pt-4'}>
          <Col className={'col-6 text-start'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span
                className={'text-start text-sub1 fw-normal lh-xs'}
              >
                After-Tax
              </span>
            </Container>
          </Col>
          <Col className={'col-6 text-end'}>
            <span
              className={'text-start text-caption fw-light'}
            >
              {formatPrice(17.5, 'en-US', {
                currency: 'USD',
                style: 'currency',
                minimumFractionDigits: 2,
              })}
            </span>
          </Col>
        </Row>
        <Row className={'border-top-light-gray py-4 justify-content-lg-between'}>
          <Col className={'col-6 col-lg-3'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span className={'text-sub1 fw-normal lh-xs text-start'}>
                Confirmation
              </span>
              <span
                className={'text-sub1 fw-light lh-xs text-start'}
              >
                14252120616
              </span>
            </Container>
          </Col>

          <Col className={'col-6 col-lg-3'}>
            <Container className={'px-0 fit-content d-flex flex-column ms-0'}>
              <span className={'text-sub1 fw-normal lh-xs text-lg-start text-end'}>
                Submitted
              </span>
              <span className="text-sub1 fw-light lh-xs text-start">
                {formatDate(initialDate, DateFormats.LONG)}
              </span>
            </Container>
          </Col>

          <Col
            className={
              'd-flex flex-column-reverse flex-lg-column col-12 col-lg-3 mt-7 mt-lg-0'
            }
          >
            {!(COBRA_PERSONAS.indexOf(selectedPersona) > -1) && (
              <Button
                className={'ms-lg-13 mb-0 mb-lg-3 mt-3 mt-lg-0'}
                variant={'primary-outline'}
                size={'sm'}
                onClick={() => setSubmitted(false)}
              >
                Change Elections
              </Button>
            )}

            <BenefitElectionModal
              showBenefitElectionsModal={showBenefitElectionsModal}
              handleCloseBenefitElectionsModal={
                handleCloseBenefitElectionsModal
              }
            />
          </Col>
        </Row>
       
        <div className={'d-none d-lg-block mt-10'}>
          <Blockquote variant="primary">
            <div className={'mt-2 text-ligther-grey'}>
              You can make changes to this event until <strong>
                {formatDate(dueDate, DateFormats.LONG)}</strong>
            </div>
          </Blockquote>
        </div>
      </Container>

      <Container className="d-flex flex-column px-10 py-11 px-lg-11 border-top-light-gray">
        <Row>
          <Col className={'col-12 col-lg-9'}>
            <h5 className={'m-0 mb-7'}>For your records</h5>
            <span className={'fw-light text-sub1 lh-xs'}>
              There are multiple options for retaining a record of this
              transaction.
            </span>
          </Col>

          <Col
            className={
              'd-flex flex-column-reverse flex-lg-column col-12 col-lg-3 mt-7 mt-lg-0'
            }
          >            
            <a
              className={'text-decoration-none'}
              href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
              target={'_blank'}
              rel="noreferrer"
            >
              <Button
                leftIcon={light('file-download')}
                variant="primary-outline"
                className={'order-1 order-lg-3 w-100 mt-4 mt-lg-0'}
                size="sm"
              >
                Download/Print
              </Button>
            </a>
            <Button
              className={'order-1 order-lg-3 w-100 mt-4'}
              variant={'primary'}
              size={'sm'}
              onClick={handleShowBenefitElectionsModal}
            >
              Show Summary
            </Button>
          </Col>
        </Row>
      </Container>
 
        <Row
          className={
            'flex-column px-10 py-11 px-lg-11 bg-white solid-salmon-border mx-0 border-bottom'
          }
        >
          <Col className={'col-12 px-0'}>
            <h5 className={'m-0 mb-7'}>Action Required</h5>
            <span className={'fw-light text-sub1 lh-xs'}>
              All of your elections are complete except the following:
            </span>
          </Col>

          {notifications.map((notification, idx) => (
            <Col className={`px-0 ${idx > 1 ? 'border-bottom' : ''}`}>
              <Notification
                className={'ps-0'}
                onClick={() => {}}
                variant={'default'}
                notificationData={notification}
              />
            </Col>
          ))}
        </Row>
       

      <Container
        className={'bg-white rounded-border-bottom px-10 py-11 px-lg-11'}
      >

 
        <Row className={'mx-0'}>
          <Col className={'col-12 px-0'}>
            <h5 className={'m-0'}>Things to consider</h5>
            <span className={'fw-light text-sub1 lh-xs'}>
            Now that you're done making elections
            </span>
          </Col>

          <Col className={'col-12 px-0 mt-7'}>
            <span className={'fw-light text-sub1 lh-xs'}>
            Your COBRA elections have been saved. However, before your coverage goes into effect, your initial payment must be received and processed. When payment is received and processed, your coverage will go into effect retroactive to the day following the end of your active coverage.
            </span>
          </Col>

          <Col className={'col-12 px-0 mt-10'}>
            <span >
              <strong>Note: </strong>
            </span>
          </Col>

          <Col className={'col-12 px-0'}>
            <Row>
 

              <Col className={'col-12 ps-11 ms-1'}>
                <span className={'fw-light text-sub1 lh-xs'}>
                  <ul>
                    <li>
                    The total cost shown is for the full 102% cost of COBRA coverage.                  </li>
                  <li>
                  Your initial premium is the pro-rated amount from the date your coverage ended through the end of that month - plus the full monthly premium for each month between the date you lost coverage and the date you elected COBRA coverage.                  </li>
                  <li>
                  You have 45 days from the date you saved your COBRA elections to make your initial payment. If paying online, the initial payment must be made as a one-time payment using credit or debit card (a $10 service charge will apply), or direct debit from a checking/savings account.
                  </li>
                  <li>
                  After your coverage begins, you may return to this site to make changes to your COBRA coverage, if eligible, or to make future payments.
                  </li>
                  </ul>
         
                </span>
              </Col>
              <span><strong>Note:</strong>  <span className={'fw-light text-sub1 lh-xs'}>These elections are valid based on your current status; if your status changes, your eligibility for benefits and their related costs may change.
                  </span></span>
            </Row>
          </Col>

        
          
        </Row>
      </Container>
    </Container>
  );
};

const EnrollmentSuccessPage = ({ setSubmitted }: any) => {
  return <EnrollmentSuccess setSubmitted={setSubmitted} />;
};

export default EnrollmentSuccessPage;
